<template>
  <component :is="el" :id="id" class="dropdown flex items-center relative">
    <span>{{ title }}</span>

    <svg-icon name="chevron-down" class="w-2 h-2 ml-2 text-white" />

    <div
      class="dropdown__items hidden absolute z-20 left-0 bottom-0 border-t-17 border-transparent transform translate-y-full"
    >
      <ul class="rounded-3xs text-sm shadow-custom-1 text-left space-y-5 p-5 bg-white text-primary-700">
        <li
          v-for="(link, index) of links"
          :key="id + '-' + index"
          class="border-b-1 border-tertiary-600 last:border-0 pb-4 last:pb-0"
        >
          <span v-if="!link.url">
            {{ link.title }}
          </span>
          <AppLink v-else-if="!link.external" :to="link.url">
            {{ link.title }}
          </AppLink>
          <a v-else :href="link.url" target="_blank" rel="noreferrer">{{ link.title }}</a>
        </li>
      </ul>
    </div>
  </component>
</template>

<script setup lang="ts">
type DropdownLink = {
  title: string;
  url: string;
  external?: boolean;
};

defineProps({
  id: { type: String, required: true },
  el: {
    type: String,
    default: 'button',
  },
  title: {
    type: String,
    required: true,
  },
  links: {
    type: Array as PropType<Array<DropdownLink>>,
    required: true,
  },
});
</script>

<style lang="postcss">
.dropdown {
  &:hover .dropdown__items {
    display: block;
  }
}

.dropdown__items {
  width: max-content;
  min-width: 160px;
  max-width: 25vw;
}
</style>
